import { ActionIcon } from '@mantine/core';
import { LogOutIcon } from '@zenos/front-end-ui-icons';
import { useNavigate } from 'react-router';
import { logOut } from '../api/auth';
import { useAuth } from '../hooks/useAuth';

export const SignOutButton = () => {
  const { clearToken } = useAuth();
  const navigate = useNavigate();

  const signOut = async () => {
    await logOut();
    clearToken();
    navigate('/');
  };

  return (
    <ActionIcon title="Sign out" onClick={signOut} variant="transparent">
      <LogOutIcon />
    </ActionIcon>
  );
};
